import { createFileRoute } from "@tanstack/react-router";

import { BrandsPage } from "@/features/brands";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/brands/")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Brands");

  return <BrandsPage />;
}
